import React, { use, useEffect, useState } from "react";
import TopLandingNav from "../TopLandingNav/TopLandingNav";
import fastimg from "../../assets/images/fast.png";
import premiumimg from "../../assets/images/premium.png";
import familyimg from "../../assets/images/family.png";
import systemimg from "../../assets/images/system.png";
import domesticworkerimg from "../../assets/images/domesticworker.jpg";
import domesticworkersimg from "../../assets/images/domesticworker-2.jpg";
import familyNewimng from "../../assets/images/family-2.jpg";
import Testimonial from "../Testimonial/Testimonial";
import StatsBar from "../StatsBar/StatsBar";
import "./LandingPageStyle.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../Redux/loadingReducer";
import Footer from "../Footer/Footer";
import TextInput from "../ui/input/TextInput";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { selectedCoverPlanMedical } from "../../Redux/LogsRedux/Medical/MedicalLeadsRedux";
import { useTranslation } from "react-i18next";
import domainMiddleware from "../../middleware/domainMiddleware";
import LegalTrustStatus from "../LegalTrustStatus/LegalTrustStatus";



const validationSchema = Yup.object({
  name: Yup.string()
    .required("Full name is required")
    .test('no-script', 'Script tags are not allowed', value => !/<script/i.test(value)),

  mobileNumber: Yup.string()
    .matches(/^\d{8}$/, "Enter 8 digits")
    .required("Mobile number is required"),

  termsCondition: Yup.boolean()
    .oneOf([true], "You must accept the Privacy Policy"),
});

function LandingPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = {
    name: "",
    mobileNumber: "",
    termsCondition: false,
  };

  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    termsCondition: false,
  });

  const handleSubmit = async (values) => {
    let PARTNER_ID = sessionStorage.getItem('PARTNER_ID');
    
    if (!PARTNER_ID) {
      try {
        await dispatch({ type: 'domain/checkDomain' });
        await new Promise(resolve => setTimeout(resolve, 500));
        PARTNER_ID = sessionStorage.getItem('PARTNER_ID');
        
      } catch (error) {
        console.error('Error fetching PARTNER_ID:', error);
        return;
      }
    }
    
    const data = {
      "partnerId": PARTNER_ID,
      "journeyCode": "MEDICAL",
      "fullName": values.name,
      "mobileNo": values.mobileNumber,
      "leadStatus": "CREATED",
      "journeyStatus": "INITIATED"
    };
    
    dispatch(selectedCoverPlanMedical(data)).then((response) => {
      if (response && response.success) {
        localStorage.setItem('MEDICAL_LEAD_ID', response.data);
        navigate("/choose-your-plan", { state: { ...values } });
      }
    });
  };

  const handleKeyPress = (e, plan) => {
    // trigger click on Enter or Space for accessibility
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSubmit(plan);
    }
  };

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();   
  }, []);

   const { t,i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage('en');
    dispatch(setLanguage('en'));
  },[dispatch]);

  return (
    <>
      <div>
        <TopLandingNav />
      </div>
      <div className="heroImg"
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <div className="container-fluid  p-4 rounded">
          <div className="container section-header">
            <div className="row align-items-start">
              <div className="col-12 col-lg-7">
                <h2 className="section-text">MEDICAL INSURANCE</h2>
              </div>

              <div className="col-12 col-lg-5  mt-5 mt-lg-0 bg-white" >
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, errors, touched, handleChange, setFieldValue }) => (
                    <Form>
                      <div className="row shadow p-3 mb-1 rounded">

                        {/* Name */}
                        <div className="col-md-12 mt-4">
                          <TextInput
                            label="Name"
                            type="text"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Name"
                            required
                            error={touched.name && errors.name}
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        {/* Mobile Number */}
                        <div className="col-md-12 mt-1">
                          <TextInput
                            label="Mobile Number"
                            type="tel"
                            name="mobileNumber"
                            value={values.mobileNumber}
                            inputMode="numeric"
                            placeholder="Mobile Number"
                            required
                            onChange={(e) => {
                              const val = e.target.value.replace(/\D/g, "");
                              if (val.length <= 8) {
                                setFieldValue("mobileNumber", val);
                              }
                            }}
                            error={touched.mobileNumber && errors.mobileNumber}
                          />
                          <ErrorMessage
                            name="mobileNumber"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        {/* Terms & Conditions */}
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="customCheck"
                              checked={values.termsCondition}
                              onChange={(e) =>
                                setFieldValue("termsCondition", e.target.checked)
                              }
                            />
                            <label className="form-check-label ms-2" htmlFor="customCheck">
                              I accept the&nbsp;
                              <a href="https://dhofarinsurance.com/privacy-policy/">
                                <span className="text-decoration-underline primary-text">
                                  Privacy Policy
                                </span>
                              </a>
                            </label>

                            <ErrorMessage
                              name="termsCondition"
                              component="div"
                              className="text-danger small mt-1"
                            />
                          </div>
                        </div>

                        {/* Submit */}
                        <div className="col-md-12">
                          <button
                            type="submit"
                            className="btn btn-primary mb-4 mt-3"
                          >
                            Submit
                          </button>
                        </div>

                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>


      </div>
       <div className="container-fluid bg-white">
              <div className="container">
                <div className="row serviceBlock reveal delay-1">
                  <div className="col-md-4 d-flex">
                    <div className="card p-3 text-bg-light flex-row h-100 w-100">
                      <div className="img">
                        <img src={systemimg} alt="icon" className="card-img-top" />
                      </div>
                      <div className="card-body py-0 d-flex flex-column justify-content-center">
                        <h5 className="card-title">Comprehensive Medical Coverage</h5>
                        <p className="card-text">
                          Protect yourself and your family with extensive health insurance benefits for hospitalization, surgery, and medical expenses.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 d-flex">
                    <div className="card p-3 text-bg-light flex-row h-100 w-100">
                      <div className="img">
                        <img src={premiumimg} alt="icon" className="card-img-top" />
                      </div>
                      <div className="card-body py-0 d-flex flex-column justify-content-center">
                        <h5 className="card-title">Affordable Premiums</h5>
                        <p className="card-text">
                          Flexible plans with budget-friendly premiums designed to meet your healthcare needs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 d-flex">
                    <div className="card p-3 text-bg-light flex-row h-100 w-100">
                      <div className="img">
                        <img src={fastimg} alt="icon" className="card-img-top" />
                      </div>
                      <div className="card-body py-0 d-flex flex-column justify-content-center">
                        <h5 className="card-title">Hassle-Free Claims</h5>
                        <p className="card-text">
                          Quick, transparent claim settlement and access to a wide network of healthcare providers.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

      {/* Beige */}
      <div className="container-fluid px-0">
        <section className="angled-section angled--beige reveal">
          <div className="container py-3">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 px-5">
                <h2>Individual Medical</h2>
                <p>
                  Our Individual Medical Insurance plan offers comprehensive healthcare protection tailored for your personal needs. Whether you are an expatriate or an Omani resident, you get access to a wide hospital network, cashless treatments, emergency support, and quick claim approvals. Choose the coverage that fits your lifestyle and stay protected with peace of mind.
                </p>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="beigeImg">
                  <img src={familyNewimng} alt="icon" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


      {/* White */}
      <div className="container-fluid px-0">
        <section className="angled-section-white angled--white reveal delay-2">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="whiteImg">
                  <img src={familyimg} alt="icon" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 px-5">
                <h2>Affordable Health Cover</h2>
                <p>
                  Quality healthcare doesn’t have to be expensive. Affordable Health Cover is designed to provide essential medical protection at a budget-friendly cost-without compromising on care.</p>
                <p>This plan offers reliable access to medical services across Oman, making it an ideal choice for individuals and families looking for practical, everyday health coverage.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Beige */}
      <div className="container-fluid px-0">
        <section className="angled-section-after angled--beige reveal">
          <div className="container py-3">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 px-5">
                <h2>Unified Domestic Worker</h2>
                <p>
                  Caring for your home starts with caring for the people who support it. Unified Domestic Worker Insurance provides essential medical coverage for domestic workers, ensuring their well-being while offering peace of mind to employers.</p>
                <p>Designed to comply with local regulations and everyday healthcare needs, this plan offers reliable access to quality medical services across Oman.
                </p>
              </div>
              <div className="col-md-6">
                <div className="beigeImg">
                  <img src={domesticworkerimg} alt="icon" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* White */}
      {/* <div className="container-fluid px-0">
        <section className="angled-section-white angled--white reveal delay-2">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="whiteImg">
                  <img src={domesticworkersimg} alt="icon" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 px-5">
                <h2>Unified Health Insurance Plan</h2>
                <p>
                  One plan. Complete protection. The Unified Health Insurance Plan brings together essential medical coverage under a single, reliable solution designed for individuals and families in Oman.</p>
                <p>With access to trusted healthcare providers and well-rounded benefits, this plan ensures you receive quality care—whether for routine medical needs or unexpected health concerns.
                </p>
                <ul>
                  <li><b>Outpatient Services</b> Doctor consultations, diagnostics, and prescribed medications.</li>
                  <li><b>Inpatient Care</b> Hospitalization, surgeries, and specialist treatments.</li>
                  <li><b>Emergency Medical Coverage</b> Immediate care for accidents and medical emergencies.</li>
                  <li><b>Extensive Medical Network</b> Access to approved hospitals, clinics, and pharmacies across Oman.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div> */}

      {/* Beige */}
      {/* <div className="container-fluid px-0">
        <section className="angled-section-white last angled--beige reveal testimonial">
          <div className="container py-3">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12 px-5">
                <Testimonial
                  quote="ZERO has been a game-changer for our car subscriptions, giving everyone peace of mind while ensuring we never miss a payment. It’s seamless, reliable, and keeps our revenue steady — even when life throws curveballs at our customers."
                  author="SARA BAY"
                  company="X-MOBILITY" />
              </div>
            </div>
          </div>
        </section>
      </div> */}

      {/* White */}
      {/* <div className="container-fluid px-0 bg-white">
        <section className="testimonialWrapper">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12 px-5">
                <div className="statusHighlight">
                  <StatsBar />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */}
      <LegalTrustStatus/>
      <Footer />
    </>
  );
}

export default LandingPage;
